import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from '@/store';
import vuetify from './plugins/vuetify';
import '@/plugins/directus';
import '@/plugins/veevalidate';
import VueMeta from 'vue-meta';
import svgJS from '@/plugins/svg.js';
import VueCookies from 'vue-cookies';
import './registerServiceWorker';

Vue.config.productionTip = false;

Vue.use(VueMeta);
Vue.use(svgJS);
Vue.use(VueCookies);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
